import { AttendanceRouteFamily } from '@triedge/attendance-ui';
import { useYstnjAttendanceFeatureBundleState } from '../../attendance/featureBundle';

export function AttendanceSemanticRoute() {
  const { bundle, error, isLoading } = useYstnjAttendanceFeatureBundleState();

  if (isLoading) {
    return (
      <section data-extracted-from="owned:ystnj/semantic/attendance-route">
        <div data-testid="attendance-school-context-loading">Loading attendance context.</div>
      </section>
    );
  }

  if (!bundle) {
    return (
      <section data-extracted-from="owned:ystnj/semantic/attendance-route">
        <div data-testid="attendance-school-context-required">
          {error || 'Select an active school context before managing attendance.'}
        </div>
      </section>
    );
  }

  return (
    <section data-extracted-from="owned:ystnj/semantic/attendance-route">
      <AttendanceRouteFamily bundle={bundle} />
    </section>
  );
}
